<template>
  <i class="fas" :class="getOutgoingStatusIcon"/>
</template>

<script>
  export default {
    name: 'cargo-status-icon',
    props: ['status', 'etd'],
    computed: {
      getOutgoingStatusIcon() {
        let status = this.status;
        let strClass = '';
        if(status === 'waiting') {
          strClass += ' fa-truck-container';
        }
        if(status === 'loading' ) {
          strClass += ' fa-truck-loading';
        }
        if(status === 'unloading') {
          strClass += ' fas fa-truck-ramp';
        }
        if(this.etd) {
          strClass += ' red';
        }
        if(status === 'done') {
          return ' fa-check green';
        } else {
          strClass += ' fa-truck-container';
          return strClass;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .red {
    color: red !important;
  }

  .fa-truck-loading {
    color: #00c9ff;
  }

  .fa-truck-container {
    color: #0087ac;
  }

  .green {
    color: #00b954;
  }
</style>